import JobCard from "@components/common/JobCard";
import Section from "@components/common/Section";
import { Title } from "@justhome/react-ui";
import { ComponentSectionsOpenJobs, Job } from "@lib/generated/graphql";
import { FC } from "react";

const OpenJobsComponent: FC<{
  data: ComponentSectionsOpenJobs;
  jobs: Job[];
}> = ({ data, jobs }) => {
  return (
    <Section
      section={data}
      className="flex flex-col gap-m m:gap-xl py-2m m:py-5xl"
    >
      <Title>{data.title}</Title>
      <div className="grid grid-cols-1 m:grid-cols-2 l:grid-cols-3 gap">
        {jobs.map((jobCard, index) => (
          <JobCard
            key={index}
            title={jobCard.title}
            slug={jobCard.slug}
            employmentType={jobCard.employmentType}
            location={jobCard.location}
            category={jobCard.category}
            backgroundColor={jobCard.employmentTypeBackground}
          />
        ))}
      </div>
    </Section>
  );
};

export default OpenJobsComponent;
